export default "__VITE_ASSET__DWs$FCkG__"